<template>
	<a href="#" class="btn slider_info_btn" @click.prevent="clickAction" @mouseenter="animBtn" @mouseleave="animBtnRev">
		<span class="overlay"></span>
		<chevronDown :width="40"/>
	</a>
</template>
<script>
	import chevronDown from './svg_icons/chevronDown.vue';
	export default {
		name: 'sButton',
		components: {
			chevronDown
		},
		methods: {
			clickAction(){
				this.$emit('action') 
			},
			animBtn(e){
				if(e.target.querySelector('span.overlay')){ 
						let btnTweenForw = new TimelineLite()
						.to(e.target.querySelector('span.overlay'), 0.3, {css: { y: 0, force3D: true }, ease: Power2.easeOut}).to(e.target, 0.3, {css: { color: 'white' }, ease: Power0.easeOut}, '-=0.3')
					}
			},
			animBtnRev(e){
				if(e.target.querySelector('span.overlay')){ 
	        let btnTweenBackw = new TimelineLite()
	          .to(e.target.querySelector('span.overlay'), 0.3, {css: { y: -60, force3D: true }, ease: Power2.easeOut}).to(e.target, 0.3, {css: { color: '#ced4da' }, ease: Power0.easeOut}, '-=0.3')
	      }
			}
		}
	}
</script>
<style scoped lang="scss">
.slider_info_btn{
	position: relative;
	overflow: hidden;
}
</style>